<template>
  <vs-row vs-justify='center'>
    <vs-col type='flex' vs-justify='center' vs-align='center' vs-lg='12' vs-xs='12'>
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg='12' vs-xs='12' vs-sm='12'>
          <vs-card>
            <div slot='header'>
              <h3 class='card-title mb-0'>Información de filtro</h3>
            </div>
            <b-loading :is-full-page='true' v-model='isLoading'></b-loading>
            <vs-row>
              <vs-col vs-lg='4' vs-xs='12' vs-sm='12'>
                <!-- Selector de empresa -->
                <company-selector v-model='companyId' />
              </vs-col>
              <vs-col vs-lg='4' vs-xs='12' vs-sm='12'>
                <label class='vs-input--label'>Fecha de inicio</label>
                <vs-input type='date' v-model='initialDate' class='w-100 ' />
              </vs-col>
              <vs-col vs-lg='4' vs-xs='12' vs-sm='12'>
                <label class='vs-input--label'>Fecha final</label>
                <vs-input type='date' v-model='finalDate' class='w-100 ' />
              </vs-col>
            </vs-row>
            <br />
            <vs-row>
              <vs-col vs-lg='4' vs-xs='12' vs-sm='12' v-if='thereStations'>
                <label class='vs-input--label'>Estación de pago</label>
                <multiselect v-model='selectedStations' placeholder='Seleccione una estación' label='name'
                             track-by='code' :options='showStations' :multiple='true'
                             :taggable='true' :max-height='150' :max='50'>
                </multiselect>
              </vs-col>
            </vs-row>
            <hr class='custom-hr' />
            <div class='d-inline-block d-md-flex align-items-center'>
              <div class='btn-alignment'>
                <vs-button :disabled='!isSearch' @click='listClosures()'>Buscar</vs-button>
                <vs-button color='gray' @click='clearForm()'>Limpiar</vs-button>
              </div>
              <div class='ml-auto mt-3 mt-md-0'>
                <div class='d-flex align-items-center'>
                  <div class='d-flex align-items-center dropdownbtn-alignment ml-3'>
                    <vs-button :disabled='!isDownloadable' class='btnx' type='filled' color='danger'
                               @click='download()'>
                      <i class='ti-upload mr-2'></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class='btn-drop' type='filled' color='danger' icon='expand_more'></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class='dropdown-item' color="'default'" v-for='document in documents'
                                   :value='document.id' :key='document.id'
                                   :id='document.id' @click='formatType=document.id'>{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-lg='12' vs-xs='12' v-if='showTable'>
          <vs-card>
            <h3 class='card-title d-flex'>
              Tabla de previsualización
            </h3>
            <div class='border' style='max-height: 43em;
              overflow-y: auto;'
            >
              <vs-table max-items='50' pagination :data='tableData'>
                <template slot='thead'>
                  <vs-th>Usuario</vs-th>
                  <vs-th>Estación</vs-th>
                  <vs-th>Inicio sesión</vs-th>
                  <vs-th>Cierre sesión</vs-th>
                  <vs-th>Consecutivo</vs-th>
                  <vs-th>Base de caja</vs-th>
                  <vs-th>Reportado</vs-th>
                  <vs-th>Dinero en caja</vs-th>
                  <vs-th>Diferencia</vs-th>
                  <vs-th>Efectivo</vs-th>
                  <vs-th>Tarjeta</vs-th>
                  <vs-th>Otros</vs-th>
                </template>
                <template slot-scope='{data}'>
                  <vs-tr :key='indextr' v-for='(tr,indextr) in data'>
                    <vs-td :data='data[indextr].usuCode'>
                      {{ data[indextr].usuCode }}
                    </vs-td>
                    <vs-td :data='data[indextr].deviceName'>
                      {{ data[indextr].deviceName }}
                    </vs-td>
                    <vs-td :data='data[indextr].initialDate'>
                      {{ data[indextr].initialDate }}
                    </vs-td>
                    <vs-td :data='data[indextr]. finalDate'>
                      {{ data[indextr].finalDate }}
                    </vs-td>
                    <vs-td :data='data[indextr].clousureNumber'>
                      {{ data[indextr].clousureNumber }}
                    </vs-td>
                    <vs-td :data='data[indextr]. initialAmount'>
                      {{ data[indextr].initialAmount }}
                    </vs-td>
                    <vs-td :data='data[indextr].reportedValue'>
                      {{ data[indextr].reportedValue }}
                    </vs-td>
                    <vs-td :data='data[indextr].collectedAmount'>
                      {{ data[indextr].collectedAmount }}
                    </vs-td>
                    <vs-td :data='data[indextr].diferenceValue'>
                      {{ data[indextr].diferenceValue }}
                    </vs-td>
                    <vs-td :data='data[indextr].cashCollected'>
                      {{ data[indextr].cashCollected }}
                    </vs-td>
                    <vs-td :data='data[indextr].cardCollected'>
                      {{ data[indextr].cardCollected }}
                    </vs-td>
                    <vs-td :data='data[indextr].othersCollected'>
                      {{ data[indextr].othersCollected }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>

import Treeselect from '@riophae/vue-treeselect'
import CompanySelector from '../../../../components/Shared/CompanySelector'
import parkingReportsEndpoints from '@/endpoints/reports/parking-reports/parkingReportsEndpoints'
import deviceEndpoint from '@/endpoints/machine/DeviceEndpoint'
import DateUtils from '../../../../global/DateUtils'
import toast from '@/global/ToastConfig'
import Multiselect from 'vue-multiselect'
import { ROUTES } from '@/global/api_routes'


export default {
  name: 'closures',
  components: {
    Treeselect, CompanySelector,
    Multiselect
  },
  data: () => ({
    detail: false,
    showTable: false,
    thereStations: false,
    selectedStations: [],
    showStations: [],
    listStations: [],
    tableData: [],
    companyId: null,
    isLoading: false,
    formatType: null,
    finalDate: null,
    initialDate: null,
    documents: [
      { name: '.xlsx', id: 'xlsx' }
    ],
    isDownloadable: false,
    isSearch: false
  }),
  watch: {
    /**
     * Observa el companyId y realiza una accion si este cambia
     */
    companyId() {
      this.tableData = []
      this.showStations = []
      this.showTable = false
      this.initialDate = null
      this.finalDate = null
      this.selectedStations = []
      this.detail = false
      this.validateParams()
    },
    /**
     * Observa el initialDate y realiza una accion si este cambia
     */
    initialDate() {
      this.tableData = []
      this.showTable = false
      this.showStations = []
      this.selectedStations = []
      this.validateParams()
    },
    /**
     * Observa el finalDate y realiza una accion si este cambia
     */
    finalDate() {
      this.tableData = []
      this.showTable = false
      this.showStations = []
      this.selectedStations = []
      this.validateParams()
    },
    selectedStations() {
      this.tableData = []
      this.showTable = false
    },
    detail() {
      this.tableData = []
      this.showTable = false
    },
    /***
     * observa la lista de descuentos resultante del endPoint si cambia valida para inhabilitar los
     * botones de descarga y busqueda
     */
    showStations() {
      this.isSearch = false
      this.isDownloadable = false
      if (this.showStations.length > 0) {
        this.isSearch = true
        this.isDownloadable = true
      }
    }
  },
  methods: {
    clearForm() {
      this.companyId = null
      this.selectedStations = []
      this.formatType = null
      this.initialDate = null
      this.finalDate = null
      this.tableData = []
      this.showStations = []
      this.showTable = false
    },
    /**
     * metodo que valida si los parametros  de los servicios de traer los
     * metodos de pago y las estaciones son los correctos si no sale y no los muestra y no ejecuta el servicio
     * @returns {Promise<void>}
     */
    async validateParams() {
      if (!this.companyId) {
        this.thereStations = false
        return
      }
      if (!this.finalDate || !this.initialDate) {
        this.thereStations = false
        return
      }
      this.listDevices()
      this.thereStations = true

    },

    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate
        }),
        devicesIds: this.getValidateStations()
      }
    },
    async validateForm() {
      if (!this.finalDate || !this.initialDate) {
        throw new Error('Debe seleccionar fecha inicial y/o fecha final')
      }
      const validationResult = await this.$validator.validateAll()
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate
      })
      if (validDates) {
        throw new Error('Fecha final no puede ser inferior a fecha inicial')
      }
      if (!validationResult) {
        throw new Error('Complete el formulario')
      }
      if (!this.companyId) {
        throw new Error('Seleccione una compañia')
      }
    },
    async download() {
      try {
        await this.validateForm()
        this.isLoading = true
        toast.info('Cargando reporte')
        const params = this.prepareParameters()
        parkingReportsEndpoints.downloadClosures(params)
          .then(data => {
            if (data.code < 0) {
              this.isLoading = false
              return
            }
            this.isLoading = false
            let a = document.createElement('a')
            const urlFile =
              process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info
            a.href = urlFile
            document.body.appendChild(a)
            a.download = urlFile
            a.click()
          })
      } catch (error) {
        toast.error(error)
      }

    },
    async listClosures() {
      try {
        await this.validateForm()
        this.tableData = []
        this.isLoading = true
        const params = this.prepareParameters()
        parkingReportsEndpoints.listClosures(params)
          .then(data => {
            if (data.length === 0) {
              this.tableData = []
              this.isLoading = false
              this.showTable = false
              return
            }
            this.isLoading = false
            this.tableData = data
            this.showTable = true
          })
      } catch (error) {
        toast.error(error)
      }
    },
    /**
     * metodo que lista las estaciones que facturaron en el rango de fecha ingresado
     * @returns {Promise<void>}
     */
    async listDevices() {
      try {
        this.showStations = []
        await this.validateForm()
        this.isLoading = true
        const objParams = this.prepareParameters()
        deviceEndpoint.listByBillingRange(objParams)
          .then(data => {
            if (data.length === 0) {
              this.isLoading = false
              return
            }
            data.forEach((station) => {
              const unity = {
                name: station.nickname == null ? station.title : station.nickname,
                code: station.code
              }
              this.showStations.push(unity)
            })
          })
        this.isLoading = false
        this.forceRender++
      } catch (error) {
        toast.error(error.message)
      }
    },
    /**
     *  metodo que valida si seleccionaron una estacion o si no que tenga encuenta todas las estaciones
     * @returns {string}
     */
    getValidateStations() {
      return this.selectedStations.length === 0
        ? this.showStations.map(item => item.code).join(',')
        : this.selectedStations.map(item => item.code).join(',')
    }
  }
}
</script>
<style src='vue-multiselect/dist/vue-multiselect.min.css' />
